import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";
import styles from "./Published.module.scss";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useContext } from "react";
import WorkflowContext from "../../context/WorkflowContext";

const Published: React.FC = () => {
  const { currentWorkflow } = useContext(WorkflowContext);
  const { t } = useTranslation();

  return (
    <Box className={styles.published}>
      <CheckCircleIcon />
      <p>
        {t("publication")}
        <em>{currentWorkflow?.ticketNumber}</em>
        {t("wasSuccessful")}
      </p>
    </Box>
  );
};

export default Published;
